
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Toast from 'vux/src/components/toast/index.vue'

export default {
name: "",
props: [""],
data() {
return {
urls: this.$route.params.data,
zhifuUrl: "http://weixin.qq.com/q/02VOxIcWgBde210000M07k",
getData: {},
apiurl: "",
loading: false,
loginType: "",
};
},
directives: {
TransferDom,
},
components: {
Loading,
Toast,
},

computed: {},

beforeMount() {},

mounted() {
this.loginType = localStorage.getItem("login_type");
this.$http.get("./static/api/api.json").then((response) => {
this.apiurl = response.api;
this.getscanQrRent();
});
},

methods: {
gofwxy() {
this.$router.push({
path: "/service-agreement",
});
},
getscanQrRent() {
this.$http
.post(this.apiurl + "/web/scan", { qrCodeValue: this.urls })
.then((res) => {
if (res.code == 200) {
this.getData = res.data;
}
});
},
zfbtrabepay() {
var _this = this;
_this.loading = true;
const psotData = {
deviceId: _this.getData.id,
paymentFlag: _this.getData.paymentFlag,
};
_this.$http
.post(_this.apiurl + "/web/creditOrder/create", psotData)
.then((res) => {
if (res.code == 200) {
_this.loading = false;
const div = document.createElement("div");
div.innerHTML = res.data; 
document.body.appendChild(div);
document.forms[0].submit();











} else {
_this.$vux.toast.text(res.msg, "top");
}
});
},
sumbits() {
var _this = this;
_this.loading = true;
const psotData = {
deviceId: _this.getData.id,
paymentFlag: _this.getData.paymentFlag,
};
_this.$http
.post(_this.apiurl + "/web/creditOrder/create", psotData)
.then((res) => {
if (res.code == 200) {

_this.goToWXScore(res.data);














} else {
_this.$vux.toast.text(res.msg, "top");
}
_this.loading = false;
});
},
/**
* 跳转微信支付分
*/
goToWXScore(data) {
const _this = this;

let queryString =
"mch_id=" +
data.mch_id +
"&package=" +
data.package +
"&timestamp=" +
data.timestamp +
"&nonce_str=" +
data.nonce_str +
"&sign_type=" +
data.sign_type +
"&sign=" +
data.sign;
wx.checkJsApi({
jsApiList: ["openBusinessView"], // 需要检测的JS接口列表
success: function (res) {


if (res.checkResult.openBusinessView) {
wx.invoke(
"openBusinessView",
{
businessType: "wxpayScoreUse",
queryString: queryString,
},
function (res) {

if (res.err_code === 0 || res.err_code === '0') {

_this.$router.push({
path: "/longdings",
});
} else {
_this.$vux.toast.text(res.msg, "top");

}
}
);
}
},
});
},
},

watch: {},
};



// WEBPACK FOOTER //
// ./src/components/paymentfree.vue